import { render, staticRenderFns } from "./Fullscreen-modal.vue?vue&type=template&id=da5e4b38&scoped=true&"
import script from "./Fullscreen-modal.vue?vue&type=script&lang=js&"
export * from "./Fullscreen-modal.vue?vue&type=script&lang=js&"
import style0 from "./Fullscreen-modal.vue?vue&type=style&index=0&id=da5e4b38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5e4b38",
  null
  
)

export default component.exports